// Keep shared cart/dialog/events infrastructure global. These leaf owners load
// on presence, including AJAX sections and quick-add content on any route.
const urls = JSON.parse(document.querySelector('script[data-giesto-components]').dataset.giestoComponents);
const pending = new Map();
const failed = new Set();
const replaying = new WeakSet();
const selector = Object.keys(urls).join(',');
const load = element => {
  const name = element.localName;
  if (customElements.get(name)) return Promise.resolve();
  const url = urls[name];
  if (!pending.has(url)) pending.set(url, import(url).catch(error => { failed.add(url); console.warn('[Giesto component]', name, error); }));
  return pending.get(url);
};
const scan = root => {
  if (root.matches?.(selector)) load(root);
  for (const element of root.querySelectorAll?.(selector) || []) load(element);
};
scan(document);
new MutationObserver(records => { for (const record of records) for (const node of record.addedNodes) if (node.nodeType === 1) scan(node); }).observe(document.documentElement, { childList: true, subtree: true });
for (const type of ['pointerdown', 'focusin']) document.addEventListener(type, event => { const owner = event.target.closest?.(selector); if (owner) load(owner); }, { capture: true, passive: true });
document.addEventListener('click', event => {
  const owner = event.target.closest?.(selector);
  if (!owner || customElements.get(owner.localName) || event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const target = event.target.closest('button, a, input');
  if (!target || replaying.has(target) || failed.has(urls[owner.localName])) return;
  // Native links do not depend on formatting or positioning a leaf component.
  // Keep browser activation intact, including new windows and downloads.
  if (target.matches('a[href]') && (!target.closest('[on\\:click]') || target.hasAttribute('download') || (target.target && target.target !== '_self'))) return;
  event.preventDefault(); event.stopImmediatePropagation();
  load(owner).then(() => {
    if (!owner.isConnected || !target.isConnected || !owner.contains(target)) return;
    // Replay once even after failure so native defaults and eager handlers can run.
    // The bypass prevents a failed, still-unregistered owner from intercepting it.
    replaying.add(target);
    try { target.click(); } finally { replaying.delete(target); }
  });
}, { capture: true });
